import { useEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap/all';
import { Text, Image } from '@weareconceptstudio/core';

//* Styles
import DescriptionStyle from './style';

//* Component
import Editor from '@/components/Editor';

gsap.registerPlugin(ScrollTrigger);

const Description = ({ items, imageLoad }) => {
	//! Ref
	const itemRefs = useRef([]);
	const scrollRef = useRef([]);

	useEffect(() => {
		if (itemRefs.current.length && imageLoad) {
			itemRefs.current.forEach((item, ind) => {
				const title = item.querySelector('.title-text');
				const editor = item.querySelector('.wrap-editor');
				const image = item.querySelector('.image-wrapper');
				const subtitle = item.querySelector('.wrapper-subtitle');
				const editorChildren = editor.children || [];

				scrollRef.current[ind] = ScrollTrigger.create({
					start: 'top bottom',
					end: 'top top',
					// markers: true,
					trigger: item,
					onEnter: () => {
						gsap.set(editor, { opacity: 1 });
						gsap.fromTo([title, ...editorChildren, image].filter(Boolean), { opacity: 0 }, { opacity: 1, duration: 0.5, ease: 'power2.in', stagger: 0.1 });

						const delayedCalc = editorChildren.length + 1;

						if (image) {
							gsap.fromTo(image, { y: '40%' }, { y: 0, duration: 0.6, ease: 'power2.out', delay: delayedCalc * 0.1 });
						}
						if (subtitle) {
							const subtitleDelay = (delayedCalc + 1) * 0.1;
							gsap.fromTo(subtitle, { opacity: 0 }, { opacity: 1, duration: 0.5, ease: 'power2.in', stagger: 0.1, delay: subtitleDelay });
						}
					},
					onLeaveBack: () => {
						if (editorChildren?.length) {
							gsap.set([...editorChildren], { opacity: 0 });
						}
						gsap.set([title, editor, image], { opacity: 0 });
					},
				});
			});
		}

		return () => {
			if (scrollRef.current.length) {
				scrollRef.current.forEach((item) => item.kill());
			}
		};
	}, [items, imageLoad]);

	return (
		<DescriptionStyle>
			{items.map((item, i) => {
				return (
					<div
						key={i}
						className={'wrapper-information'}
						ref={(el) => (itemRefs.current[i] = el)}>
						{item?.title ? <Text className={'font-fss-regular title-text h5 opacity-zero'}>{item.title}</Text> : null}

						<div className='wrap-editor opacity-zero'>
							<Editor
								data={item.description}
								className={'wrapper-desc'}
							/>
						</div>

						{item?.image ? (
							<div className={'image-wrapper opacity-zero'}>
								<Image
									src={item.image.src}
									alt={item.image.alt}
								/>
							</div>
						) : null}

						{item?.description_2 ? (
							<Editor
								data={item.description_2}
								className={'wrapper-subtitle'}
							/>
						) : null}
					</div>
				);
			})}
		</DescriptionStyle>
	);
};

export default Description;
